<template>
  <div>
    <Head />
    <div class="wrap">
      <h1>Быков Николай Юрьевич</h1>
      
        <div><img class='ii' alt="" src="../assets/bnu2.png" /></div>
        <div><img class='ii' alt="" src="../assets/bnu3.jpg" /></div>
        <div><img class='ii' alt="" src="../assets/bnu4.jpg" /></div>
        <div><img class='ii' alt="" src="../assets/bnu5.jpg" /></div>
        <div><img class='ii' alt="" src="../assets/bnu6.jpg" /></div>
     
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'

export default {
  name: 'BnuView',
  components: {
    Head,
    Foot,
  }
}
</script>

<style scoped>
.wrap {
  max-width: 90%;
  margin: 60px auto;
}

.ii {
  width: 100%;
  overflow: hidden;
  object-fit: cover;
}


@media (max-width: 790px) {

  

}

</style>

